import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Layout from "../../Layout/Layout";
import { isAuthenticated } from "../../auth";
import { elakayAutoText as text } from "../../pageInside/dataElakay";
import DropshippingInterneLayout from "../components/DropshippingInterneLayout";
import ProviderNotice from "./ProviderNotice";
import "../seller/DropshippingIn.css";
import "./center.css";

export const tokenOf = () => isAuthenticated()?.token;

// Loads data through `fetcher(token)`; exposes loading/error/reload so every page has real
// loading, error and empty states.
export const useLoad = (fetcher, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const reload = useCallback(async () => {
    setLoading(true);
    const r = await fetcher(tokenOf());
    if (r?.error || r?.success === false) setError(r.error || text("h_7f2f6a15cf8da2", "Error")); else { setError(""); setData(r); }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  useEffect(() => { reload(); }, [reload]);
  return { data, loading, error, reload };
};

export const Status = ({ value }) => <span className={`ctr-status ctr-status--${value}`}>{value}</span>;

// `embedded`: render only the page body (header + states + content) inside another page -- e.g.
// Provider My Shop's ORDERS tab reuses the real Orders page instead of a second orders system.
export default function PageShell({ infoSource, titleElakay = "providerProducts", crumb, title, subtitle, icon = "fa-store", className = "", actions, state, embedded = false, children }) {
  // Provider pages belong to Provider Center; Seller-side pages (e.g. /seller/provider-orders) keep
  // the Sell Center (Seller My Shop) root.
  const { pathname } = useLocation();
  const providerSide = /^\/provider(\/|$)/.test(pathname);
  const body = <>
    <header className="ctr__head">
      <div className="ctr__heading">
        <span className="ctr__head-icon" aria-hidden="true"><i className={`fas ${icon}`} /></span>
        <div className="ctr__heading-copy"><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div>
      </div>
      {actions && <div className="ctr__head-actions">{actions}</div>}
    </header>
    {state?.loading && <div className="dsi-skeleton" role="status" aria-busy="true"><div className="dsi-skeleton__shop" /></div>}
    {!state?.loading && state?.error && <div className="dsi-state-card" role="alert"><h2>{text("h_spm_error_title", "Something went wrong")}</h2><p>{state.error}</p><button type="button" className="dsi-state-card__btn" onClick={state.reload}>{text("h_spm_retry", "Retry")}</button></div>}
    {!state?.loading && !state?.error && children}
  </>;
  if (embedded) return <div className={`ctr ctr--embedded ${className}`.trim()}>{body}</div>;
  return (
    <Layout infoSource={infoSource} titleElakay={titleElakay} SliderPunShow={false} loading={false} outOffPage={false} {...infoSource?.allSettings?.layout} showFooter={true}>
      <DropshippingInterneLayout infoSource={infoSource}>
        <div className={`dsi-page ctr ${className}`.trim()}>
          <nav className="dsi-breadcrumb" aria-label={text("h_c766e665183df1", "Breadcrumb")}>
            {providerSide
              ? <Link to="/provider">{text("h_pvc_title", "Provider Center")}</Link>
              : <Link to="/myShop">{text("h_spm_sell_center", "Sell Center")}</Link>}
            <span aria-hidden="true">›</span><span aria-current="page">{crumb || title}</span>
          </nav>
          <ProviderNotice />
          {body}
        </div>
      </DropshippingInterneLayout>
    </Layout>
  );
}
